import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import baseUtil from "./assets/js/util";
import {message} from "./assets/js/resetMessage";
import axios from './http'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video
Vue.config.productionTip = false;

Vue.use(baseUtil)
Vue.use(ElementUI);
Vue.prototype.$axios = axios
axios.defaults.headers.post['Content-Type'] ='application/json';
Vue.prototype.interfaceJson = require('./assets/json/interface.json');
console.log(Vue.prototype.interfaceJson.ipUrl)
// Vue.prototype.UKJSON = require(Vue.prototype.interfaceJson.ipUrl+'/credit-rule/UK_v2.json');

Vue.prototype.$message = message;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
